// DO NOT EDIT -- generated from Go package fs/auth

///////////
// Enums //
///////////

export enum AuthMethod {
	AuthMethodFullStory = "fullstory",
	AuthMethodGoogle = "google",
	AuthMethodAuth0 = "auth0",
	AuthMethodToken = "token",
	AuthMethodAPI = "api",
	AuthMethodImpersonated = "impersonated",
	AuthMethodDoorman = "doorman"
}


///////////////
// Constants //
///////////////

export const NobodyAtLocalhost: string = "nobody@localhost";
